<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :inline="true" :rules="rules">
        <div class="block">
          <div class="contit">基础信息</div>

          <FormItem v-for="(c, i) in formCtrl" :key="'form0Item' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <!-- 提成金额 -->
          <div v-show="showCtrl">
            <FormItem v-for="(c, i) in formCtrl1" :key="'form1Item' + i" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem v-for="(c, i) in formCtrlIn" :key="'formInItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput"
            @onSelect="onSelect" />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem v-for="(c, i) in formCtrlOut" :key="'formOutItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput"
            @onSelect="onSelect" />
        </div>

      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'contract',
      breadcrumb: [
        { name: "合同管理", path: `/contract/list` },
        { name: "合同列表", path: `/contract/list` },
        { name: "合同添加" },
      ],
      form: {
        shipperid: undefined,
        nid: undefined,
        cprice: undefined,
        drman: undefined,
        drtel: undefined,
        coaddress: undefined,
        enman: undefined,
        ertel: undefined,
        enaddress: undefined,
        ton: undefined,
        dprice: undefined,
        is_tax: 0,
        is_commission: 0,
      },
      rules: {
        is_tax: [
          { required: true, message: "请选择是否含税", trigger: "blur" },
        ],
        shipperid: [
          { required: true, message: "请选择客户名称", trigger: "blur" },
        ],
        // timerange: [
        //   { required: true, message: "请选择合同期限", trigger: "blur" },
        // ],
        nid: [
          { required: true, message: "请选择货物名称", trigger: "blur" },
        ],
        ton: [
          { required: true, validator: this.checkTon, trigger: "blur" },
        ],
        cprice: [
          { required: true, message: "请填写公司单价", trigger: "blur" },
        ],
        dprice: [
          { required: true, message: "请填写司机单价", trigger: "blur" },
        ],
        drman: [
          { required: true, message: "请填写装货联系人", trigger: "blur" },
        ],
        drtel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
        coaddress: [
          { required: true, message: "请填写装货地址", trigger: "blur" },
        ],
        enman: [
          { required: true, message: "请填写卸货联系人", trigger: "blur" },
        ],
        ertel: [
          { required: true, validator: this.checkPhone, trigger: "blur" },
        ],
        enaddress: [
          { required: true, message: "请填写卸货地址", trigger: "blur" },
        ],
      },
      showCtrl: false,
      formCtrl: [
        {
          label: "合同编号",
          keyName: "con_num",
          err: "请填写合同编号",
          type: "text",
          disabled: true,
        },
        {
          label: "客户名称",
          keyName: "shipperid",
          err: "请选择客户名称",
          type: "select",
          options: [],
        },
        {
          label: "合同期限",
          keyName: "timerange",
          err: "请选择合同期限",
          type: "daterange",
          unit: "（选填）",
        },
        {
          label: "货物名称",
          keyName: "nid",
          err: "请选择货物名称",
          type: "select",
          options: [],
        },
        {
          label: "运送重量",
          keyName: "ton",
          err: "请填写运送重量",
          type: "number",
        },
        {
          label: "公司单价",
          keyName: "cprice",
          err: "请填写公司单价",
          type: "number",
        },
        {
          label: "司机单价",
          keyName: "dprice",
          err: "请填写司机单价",
          type: "number",
        },
        {
          label: "是否含税",
          keyName: "is_tax",
          err: "请选择是否含税",
          type: "select",
          clearable: true,
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 0 },
          ],
        },
        {
          label: "有无提成",
          keyName: "is_commission",
          err: "请选择有无提成",
          type: "select",
          options: [
            { label: '有', value: 1 },
            { label: '无', value: 0 },
          ],
        },
      ],
      formCtrl1: [
        {
          label: "提成金额",
          keyName: "commission",
          err: "请填写提成金额",
          type: "number",
        },
        {
          label: "用餐补贴金额",
          keyName: "meal",
          err: "请填写用餐补贴金额",
          type: "number",
        },
        {
          label: "住宿补贴金额",
          keyName: "stay",
          err: "请填写住宿补贴金额",
          type: "number",
        },
      ],
      formCtrlIn: [
        {
          label: "装货联系人",
          keyName: "drman",
          err: "请填写装货联系人",
          type: "text",
          options: [],
        },
        {
          label: "装货人电话",
          keyName: "drtel",
          err: "请填写装货电话",
          type: "number",
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          options: [],
        },
      ],
      formCtrlOut: [
        {
          label: "卸货联系人",
          keyName: "enman",
          err: "请填写卸货联系人",
          type: "text",
          options: [],
        },
        {
          label: "卸货人电话",
          keyName: "ertel",
          err: "请填写卸货电话",
          type: "number",
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          options: [],
        },
      ],
    };
  },
  methods: {
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      if (key === 'is_commission') {
        this.form[key] = value;
        this.showCtrl = (value == '1')
      } else {
        this.form[key] = value;
      }
      // console.log({ ...this.form });
    },
    setDetail() {
      const formCtrl = [
        ...this.formCtrl,
        ...this.formCtrl1,
        ...this.formCtrlIn,
        ...this.formCtrlOut,
      ]
      formCtrl.map(v => {
        const key = v.keyName
        this.form[key] = this.detail[key];
        if (key === 'timerange') {
          this.form[key] = [this.detail['starttime'], this.detail['endtime']]
        }
      })
      if (this.detail.is_commission == 1) {
        this.showCtrl = true
      }
      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    paramsPackage(params, object) {
      // console.log({ ...params }, { ...object })
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && key !== 'timerange') {
          params[key] = object[key];
        }
      }
      if (object['timerange']) {
        const [starttime, endtime] = object['timerange']
        params['starttime'] = starttime
        params['endtime'] = endtime
      }

      const opt = this.id ? 'update' : 'create'
      // console.log(opt)
      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'contract',
      }
      // console.log({ ...params }, { ...object })
    },
    setOptions({ custom, product, con_num }) {
      if (!this.form.con_num) {
        this.form.con_num = con_num
      }
      this.formCtrl.map(c => {
        if (c.keyName == 'shipperid' && custom.length) {
          c.options = custom.map(v => {
            return {
              label: `${v.name}-${v.member}`,
              value: v.id,
            }
          })
        } else if (c.keyName == 'nid' && product.length) {
          c.options = product.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
        }
        this.$forceUpdate()
      })
    },
    onInput({ key, value }) {
      // console.log(key, value, this.form.shipperid)
      const id = this.form.shipperid
      if (id && value) {
        this.inputSearch(id, key, value)
      } else if (!value) {
        if (key === 'drman') {
          this.formCtrlIn[0]['options'] = []
          this.form[key] = value
        } else if (key === 'coaddress') {
          this.formCtrlIn[2]['options'] = []
          this.form[key] = value
        } if (key === 'enman') {
          this.formCtrlOut[0]['options'] = []
          this.form[key] = value
        } if (key === 'enaddress') {
          this.formCtrlOut[2]['options'] = []
          this.form[key] = value
        }
        this.$forceUpdate()
      }
      // console.log({ ...this.form })
    },
    inputSearch(id, key, value) {
      // console.log(id, key, value)
      let url = `order/shippervague`;
      const params = {
        id,
      }
      if (key === 'drman') {
        params['fhperson'] = value
      } else if (key === 'coaddress') {
        params['fhdizhi'] = value
      } if (key === 'enman') {
        params['shperson'] = value
      } if (key === 'enaddress') {
        params['shdizhi'] = value
      } else if (!['drman', 'coaddress', 'enman', 'enaddress'].includes(key)) {
        return
      }
      // console.log(url, params)
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          if (key === 'drman') {
            this.formCtrlIn[0]['options'] = data.map(v => {
              return {
                label: v.member,
                value: v.id,
                data: v,
              }
            })
          } else if (key === 'coaddress') {
            this.formCtrlIn[2]['options'] = data.map(v => {
              return {
                label: v.address,
                value: v.id,
                data: v,
              }
            })
          } if (key === 'enman') {
            this.formCtrlOut[0]['options'] = data.map(v => {
              return {
                label: v.member,
                value: v.id,
                data: v,
              }
            })
          } if (key === 'enaddress') {
            this.formCtrlOut[2]['options'] = data.map(v => {
              return {
                label: v.address,
                value: v.id,
                data: v,
              }
            })
          }
          this.$forceUpdate()
          // console.log([...this.formCtrlIn])
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSelect({ key, value }) {
      // console.log(key, value)
      if (key === 'drman') {
        this.formCtrlIn[0]['options'] = []
        this.form[key] = value['member']
        this.form['drtel'] = value['phone']
      } else if (key == 'coaddress') {
        this.formCtrlIn[2]['options'] = []
        this.form[key] = value['address']
      } if (key === 'enman') {
        this.formCtrlOut[0]['options'] = []
        this.form[key] = value['member']
        this.form['ertel'] = value['phone']
      } if (key === 'enaddress') {
        this.formCtrlOut[2]['options'] = []
        this.form[key] = value['address']
      }
      this.$forceUpdate()
    },
  },
  created() {
    if (this.mode === 'edit') {
      this.formCtrl[1].disabled = true
    }
  },
  mounted() {
    this.getOptions()
  },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
